import React from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import classnames from 'classnames';
import {usePopupNotesContext} from '../../contexts/PopupNotesContext';
import ModalCommon from "../../../ModalCommon";
import ButtonCommon from "../../../ButtonCommon";
import FieldSelect from "../../../FieldSelect";
import FieldDatepicker from "../../../FieldDatepicker";
import FieldTextareaAutosize from "../../../FieldTextareaAutosize";
import plus from '../../../../assets/add-button.svg';
import styles from '../../styles.module.scss';

const PopupCreateNote = ({onOpen, onEdit, disabled}) => {
  const {formik} = usePopupNotesContext();
  const {values, isValid, dirty} = formik;
  const {users, noteStatusTypes} = useSelector((state) => ({
    users: state?.firmUsersReducer?.users,
    noteStatusTypes: state?.generalNoteStatusTypesReducer?.generalNoteStatusTypes,
  }), shallowEqual);

  return (
    <>
      <ModalCommon
        size={'md'}
        header={'עדכון'}
        customModalTrigger={
          <ButtonCommon
            label={
              <div className={styles.createNoteButtonLabel}>
                <img src={plus} alt="create"/>
                <span>{'עדכון'}</span>
              </div>
            }
            customContainerStyles={styles.createNoteButton}
            disabled={disabled}
          />
        }
        disableActionButton={!isValid || !dirty}
        handleAction={async () => {
          if (onEdit) await onEdit(-1);
        }}
        getDataOnOpenModal={() => {
          if (onOpen) onOpen();
        }}
      >
        <div className={styles.noteFormContainer}>
          <FieldSelect
            fieldId={'statusTypeID'}
            options={noteStatusTypes ?? []}
            mandatoryMark={true}
            label={'סטטוס'}
            containerStyles={styles.marginBottom25}
          />
          <FieldDatepicker
            fieldId="dueDate"
            value={values.dueDate}
            label={'תאריך לביצוע'}
            datepickerStyles={styles.width100}
            boxStyles={styles.width100}
            containerStyles={classnames(styles.marginBottom25, styles.width100)}
          />
          <FieldSelect
            fieldId={'responsibleUserID'}
            options={users ?? []}
            label={'גורם מטפל'}
            containerStyles={styles.marginBottom25}
          />
          <FieldTextareaAutosize
            fieldId="freeText"
            value={values.freeText}
            label={'תיאור'}
            maxRows={6}
          />
        </div>
      </ModalCommon>
    </>
  );
};

export default PopupCreateNote;